import { render, staticRenderFns } from "./loading-elipsis.vue?vue&type=template&id=c78371ce&scoped=true"
import script from "./loading-elipsis.vue?vue&type=script&lang=js"
export * from "./loading-elipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78371ce",
  null
  
)

export default component.exports